var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStairs = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "stairs_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#stairs_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M10.278 29.722h6.82V24.18h4.29V18.64h4.292v-5.584h4.042v-2.777h-6.82v5.542h-4.29v5.541H14.32v5.584h-4.042v2.777ZM5 35V5h30v30H5Zm2.778-2.778h24.444V7.778H7.778v24.444Z"
}))));
export default SvgStairs;